export const linkTitle = (linkData) => {
    return (linkData.title ? linkData.title : "«No title»") + " by " +
        (linkData.author ? linkData.author : "«no author»") +
        (linkData.twitterHandle ? " (@" + linkData.twitterHandle + ")" : "")
}



// WEBPACK FOOTER //
// ./src/dashboard/links/linkService.js